module.exports = __webpack_public_path__ + "media/images/lp_left-74655014e8b9b0f3ceda79f5f1f37831.webp";